import React, { useState, useEffect } from 'react';

import './FooterJunni.scss';

export const FooterJunni = () => {
  const [isSticky, setIsSticky] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.footer-junni');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Remove sticky class when footer is visible in viewport
        if (footerRect.top <= windowHeight) {
          setIsSticky(false);
        } else {
          setIsSticky(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`footer-junni ${isSticky ? 'is-sticky' : ''}`}>
      <div className="footer-junni__inner">
        <a
          className="footer-junni__btn footer-junni__btn--left"
          href="/sg/en/eyeglasses/brands/Junni.html"
        >
          See All Products
        </a>
        <a className="footer-junni__btn footer-junni__btn--right" href="/stores/sg">
          Search Nearby Stores
        </a>
      </div>
    </nav>
  );
};
